function cylindo360(){
  const $gallery = $('#cylindo-gallery');
  if ($gallery.length === 0) {
    return true;
  }
  const features = $gallery.data('features').split(',');
  
  var viewerInstance = null;
  var options = {
    'accountID': $gallery.data('id'),
    'SKU': $gallery.data('sku'),
    "viewerType": "2",
    'features': ["FABRIC", "COL", "FINISH", "ALPINE"], 
    'country': 'us',
    'containerID': 'cylindo-gallery'
  }

  if (cylindo) {
    cylindo.on('ready', function () {
      cylindo.viewer.create(options);
      
      //$('#product-select, .disable-select, .radio-features input').on('change', function() {
      $('.radio-features input').on('change', function() {
        var optionName = "FABRIC";
        var optionTxt = "COL";
        const featureArray =  new Array();

        if ($('.radio-holder input:checked').length > 0) {
          $('.radio-holder input:checked').each(function(){
            optionName = $(this).data('option-name');
          });

          var $productSelect = $("#product-select");
          var option_target = "";
          var $self = $(this);

          $(".radio-holder input:checked, .main-add-form .select-wrapper select option:selected").not('.disable-select option:selected').each(function() {
            var $this = $(this);
            var dataIndex = $this.data("index");
            var eleValue = $this.val();
            option_target += `[data-option-${dataIndex}="${eleValue}"]`;
          });
          var $option = $productSelect.find(option_target);

          featureArray.push(optionName);
          featureArray.push($option.text());
        } else {
          featureArray.push(optionName);
          featureArray.push(optionTxt);          
        }

        $('.radio-features input:checked').each(function(){
          var featureName = $(this).data('type');
          var featureVal = $(this).val();
          featureArray.push(featureName);
          featureArray.push(featureVal);
        });

        if(featureArray.length == 2) {
          featureArray.push("FINISH");
          featureArray.push("ALPINE");
        }

        options.features = featureArray;
        cylindo.viewer.create(options);
      })
      

      $('.radio-holder input').on('click', function() {
        var optionName = $(this).data('option-name');

        var $productSelect = $("#product-select");
        var option_target = "";
        var $self = $(this);

        $(".radio-holder input:checked, .main-add-form .select-wrapper select option:selected").not('.disable-select option:selected').each(function() {
          var $this = $(this);
          var dataIndex = $this.data("index");
          var eleValue = $this.val();
          option_target += `[data-option-${dataIndex}="${eleValue}"]`;
        });
        var $option = $productSelect.find(option_target);

        const featureArray =  new Array();
        featureArray.push(optionName);
        featureArray.push($option.text());

        $('.radio-features input:checked').each(function(){
          var featureName = $(this).data('type');
          var featureVal = $(this).val();
          featureArray.push(featureName);
          featureArray.push(featureVal);
        });

        if(featureArray.length == 2) {
          featureArray.push("FINISH");
          featureArray.push("ALPINE");
        }

        options.features = featureArray;
        cylindo.viewer.create(options);
      })

    });
  }
}

export default cylindo360();



// WEBPACK FOOTER //
// ../markup/assets/js/product-cylindo.js